import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Gallery from '../components/Gallery';
import { useLocation } from 'react-router-dom';

// Importation des images
import { 
  // Images principales
  heroImage,
  vueAerienne1, vueAerienne2, vueAerienne3,
  
  // Extérieur
  vue1, vue2,
  exterieur1, exterieur2, exterieur3, exterieur4,
  exterieurNiveau0, exterieurNiveau0_2,
  exterieurNiveau1, exterieurNiveau1_2, exterieurNiveau1_3,
  
  // Piscine
  piscine1, piscine2, piscine3, piscine4, piscine5,
  
  // Niveau 1 - Chambres
  chambre1_1, chambre1_2, chambre1_3, chambre1_4,
  chambre2_1, chambre2_2, chambre2_3, chambre2_4,
  
  // Niveau 0 - Chambres
  chambre3_1, chambre3_2, chambre3_3, chambre3_4, chambre3_5, chambre3_6,
  chambre4_1, chambre4_2, chambre4_3, chambre4_4,
  
  // Niveau 1 - Salon
  salonNiveau1_1, salonNiveau1_2, salonNiveau1_3, salonNiveau1_4, 
  salonNiveau1_5, salonNiveau1_6, salonNiveau1_7, salonNiveau1_8,
  
  // Niveau 0 - Séjour
  sejourNiveau0,
  
  // Niveau 1 - Cuisine
  cuisineNiveau1_1, cuisineNiveau1_2, cuisineNiveau1_3,
  
  // Niveau 0 - Cuisine
  cuisineNiveau0_1, cuisineNiveau0_2, cuisineNiveau0_3,
  
  // Niveau 1 - Salle de bain
  salleDeBainNiveau1,
  
  // Niveau 0 - Salle de bain
  salleDeBainNiveau0_1, salleDeBainNiveau0_2,
  
  // Pour la compatibilité avec le code existant
  terrace, diningRoom
} from '../assets/images';

const GalleryPage: React.FC = () => {
  const location = useLocation();
  const [initialCategory, setInitialCategory] = useState<string | null>(null);
  
  // Catégories de photos
  const categories = [
    'Vue Aérienne',
    'Extérieur',
    'Piscine',
    'Niveau 1 - Chambres',
    'Niveau 0 - Chambres',
    'Niveau 1 - Salon',
    'Niveau 0 - Séjour',
    'Niveau 1 - Cuisine',
    'Niveau 0 - Cuisine',
    'Salles de Bain',
  ];
  
  useEffect(() => {
    // Récupérer le paramètre 'category' de l'URL
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');
    
    // Vérifier si la catégorie existe dans notre liste de catégories
    if (categoryParam && categories.includes(categoryParam)) {
      setInitialCategory(categoryParam);
    }
  }, [location.search, categories]);

  // Images avec les nouvelles photos
  const images = [
    // Vue Aérienne
    {
      src: heroImage,
      alt: "Vue aérienne de la villa",
      category: "Vue Aérienne",
    },
    {
      src: vueAerienne1,
      alt: "Vue aérienne de la propriété",
      category: "Vue Aérienne",
    },
    {
      src: vueAerienne2,
      alt: "Vue aérienne de la villa et ses environs",
      category: "Vue Aérienne",
    },
    
    // Extérieur
    {
      src: exterieur1,
      alt: "Façade de la villa",
      category: "Extérieur",
    },
    {
      src: exterieur2,
      alt: "Vue extérieure de la villa",
      category: "Extérieur",
    },
    {
      src: exterieur3,
      alt: "Jardin de la villa",
      category: "Extérieur",
    },
    {
      src: exterieurNiveau1,
      alt: "Extérieur du niveau 1",
      category: "Extérieur",
    },
    {
      src: exterieurNiveau0,
      alt: "Extérieur du niveau 0",
      category: "Extérieur",
    },
    {
      src: vue1,
      alt: "Vue panoramique depuis la villa",
      category: "Extérieur",
    },
    
    // Piscine
    {
      src: piscine1,
      alt: "Piscine privée",
      category: "Piscine",
    },
    {
      src: piscine2,
      alt: "Piscine avec vue sur la nature",
      category: "Piscine",
    },
    {
      src: piscine3,
      alt: "Espace détente près de la piscine",
      category: "Piscine",
    },
    {
      src: piscine4,
      alt: "Piscine entourée de végétation",
      category: "Piscine",
    },
    
    // Niveau 1 - Chambres
    {
      src: chambre1_1,
      alt: "Chambre 1 au niveau 1",
      category: "Niveau 1 - Chambres",
    },
    {
      src: chambre1_2,
      alt: "Autre vue de la chambre 1",
      category: "Niveau 1 - Chambres",
    },
    {
      src: chambre2_1,
      alt: "Chambre 2 au niveau 1",
      category: "Niveau 1 - Chambres",
    },
    {
      src: chambre2_2,
      alt: "Autre vue de la chambre 2",
      category: "Niveau 1 - Chambres",
    },
    
    // Niveau 0 - Chambres
    {
      src: chambre3_1,
      alt: "Chambre 3 au niveau 0",
      category: "Niveau 0 - Chambres",
    },
    {
      src: chambre3_2,
      alt: "Autre vue de la chambre 3",
      category: "Niveau 0 - Chambres",
    },
    {
      src: chambre4_1,
      alt: "Chambre 4 au niveau 0",
      category: "Niveau 0 - Chambres",
    },
    {
      src: chambre4_3,
      alt: "Autre vue de la chambre 4",
      category: "Niveau 0 - Chambres",
    },
    
    // Niveau 1 - Salon
    {
      src: salonNiveau1_1,
      alt: "Salon au niveau 1",
      category: "Niveau 1 - Salon",
    },
    {
      src: salonNiveau1_2,
      alt: "Espace détente du salon niveau 1",
      category: "Niveau 1 - Salon",
    },
    {
      src: salonNiveau1_6,
      alt: "Vue d'ensemble du salon niveau 1",
      category: "Niveau 1 - Salon",
    },
    
    // Niveau 0 - Séjour
    {
      src: sejourNiveau0,
      alt: "Séjour au niveau 0",
      category: "Niveau 0 - Séjour",
    },
    {
      src: diningRoom,
      alt: "Salle à manger au niveau 0",
      category: "Niveau 0 - Séjour",
    },
    
    // Niveau 1 - Cuisine
    {
      src: cuisineNiveau1_1,
      alt: "Cuisine équipée au niveau 1",
      category: "Niveau 1 - Cuisine",
    },
    {
      src: cuisineNiveau1_2,
      alt: "Autre vue de la cuisine niveau 1",
      category: "Niveau 1 - Cuisine",
    },
    
    // Niveau 0 - Cuisine
    {
      src: cuisineNiveau0_1,
      alt: "Cuisine équipée au niveau 0",
      category: "Niveau 0 - Cuisine",
    },
    {
      src: cuisineNiveau0_2,
      alt: "Autre vue de la cuisine niveau 0",
      category: "Niveau 0 - Cuisine",
    },
    
    // Salles de Bain
    {
      src: salleDeBainNiveau1,
      alt: "Salle de bain au niveau 1",
      category: "Salles de Bain",
    },
    {
      src: salleDeBainNiveau0_1,
      alt: "Salle de bain au niveau 0",
      category: "Salles de Bain",
    },
  ];

  return (
    <GalleryPageContainer>
      <div className="container">
        <GalleryHeader>
          <GalleryTitle>Galerie Photo</GalleryTitle>
          <GalleryDescription>
            Découvrez la Villa Leïs Auro à travers cette sélection de photos. Notre villa de 120 m² sur deux niveaux indépendants vous offre 4 chambres, 2 salles de bain, 2 cuisines et une piscine privée. Parcourez les différentes pièces et espaces pour vous faire une idée précise de ce qui vous attend lors de votre séjour à Callas.
          </GalleryDescription>
        </GalleryHeader>
        
        <Gallery images={images} categories={categories} initialCategory={initialCategory} />
      </div>
    </GalleryPageContainer>
  );
};

const GalleryPageContainer = styled.div`
  padding: 12rem 0 8rem;
`;

const GalleryHeader = styled.div`
  text-align: center;
  margin-bottom: 5rem;
`;

const GalleryTitle = styled.h1`
  margin-bottom: 2rem;
`;

const GalleryDescription = styled.p`
  max-width: 80rem;
  margin: 0 auto 3rem;
  font-size: 1.8rem;
  color: var(--color-secondary);
`;

export default GalleryPage;
